// @flow
import React, { PureComponent } from 'react'
import Header from './components/Header/header'
import VideoList from './components/VideoList/videoList'
// import Form from './components/Form/form'
import FeedList from './components/FeedList/feedList'
import { connect } from 'react-redux'
import styles from './App.css'
import type { HeaderProps, VideoProps, UserInputProps } from './types'

type Props = {
  showNavBar: boolean,
  data: {
    header: HeaderProps,
    videos: Array<VideoProps>,
    userInput: UserInputProps
  }
}

class App extends PureComponent {
  props: Props
  render () {
    const { data, showNavBar } = this.props
    const { header, videos } = data
    // const { header, videos, userInput } = data
    const { title, summary, video } = header
    return (
      <div className={styles.app}>
        {showNavBar && (
          <div className={styles.appnav} >
            <svg width='3.5em' height='1.4em' aria-hidden='true'><use xlinkHref='#nrk-logo-nrk' /></svg>
          </div>
        )}
        <Header title={title} summary={summary} video={video} />
        <VideoList videos={videos} />
        <FeedList />
        <div className={styles.footerByline}>
          <ul>
            <li>
              <h3>Video og tekst</h3>
              <ul>
                <li>Gry Kårstad</li>
                <li>Even Kjølleberg</li>
                <li>André Håker</li>
                <li>Vicky Schaubert</li>
                <li>Pål Solum</li>
              </ul>
            </li>
            <li>
              <h3>Digital historieutvikling</h3>
              <ul>
                <li>Glen Imrie</li>
                <li>Stian Lund Johansen</li>
              </ul>
            </li>
            <li>
              <h3>Prosjektleder</h3>
              <ul>
                <li>Kim Jansson</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    )
  }
}

export default connect((state) => {
  return {
    data: state.data,
    showNavBar: state.app.showNavBar
  }
})(App)



// WEBPACK FOOTER //
// ./src/shared/App.js